import { orange } from "@ant-design/colors";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@lib/constants";
import { useTypedSelector } from "@lib/redux";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiGetTransactions } from "@lib/api/transaction";
import { MdPayments } from "react-icons/md";
import { AppContext } from "@lib/types";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";

type Props = {
  useInWhichContext: AppContext;
  color?: string;
  cardProps?: AppCardProps;
};

export default function PaymentHistoriesMiniCard(props: Props) {
  const { useInWhichContext, color = orange[5], cardProps } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();
  const { selectedPaymentProvider } = useTypedSelector((state) => state.cache);
  const { selectedCustomer } = useTypedSelector((state) => state.cache);

  const initialFilters = [
    ...(useInWhichContext === AppContext.PAYMENT_PROVIDER &&
    selectedPaymentProvider?.id
      ? [`providerId||$eq||${selectedPaymentProvider.id}`]
      : []),
    ...(useInWhichContext === AppContext.CUSTOMER && selectedCustomer?.id
      ? [`customerId||$eq||${selectedCustomer.id}`]
      : []),
  ];

  const [params, setParams] = useState({
    sort: "externalId,DESC",
    join: ["customer", "provider"],
    filter: initialFilters,
  });

  useEffect(() => {
    setParams({
      ...params,
      filter: initialFilters,
    });
  }, [selectedPaymentProvider]);

  const { data, isLoading } = useQuery({
    queryKey: ["dashboard-minicard-payment-histories", JSON.stringify(params)],
    queryFn: () =>
      apiGetTransactions({
        ...params,
      }),
  });
  const apiData = data?.data?.data;

  const total = apiData?.length;
  const newTotal =
    apiData?.filter((d) => {
      const createdAt = dayjs(d.createdAt);
      const startOfMonth = dayjs().startOf("day");
      const endOfMonth = dayjs().endOf("day");

      return createdAt.isBetween(startOfMonth, endOfMonth, null, "[]");
    }) || [];

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.PAYMENT_PROVIDER.PAYMENT_HISTORY.LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <MdPayments />,
        color: color,
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["common.payment"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: newTotal.length,
            duration: messages["common.thisDay"] as string,
          },
        },
      }}
    />
  );
}
